import React from 'react'

import styles from './GlitchText.module.css'

interface GlitchTextProps {
  children: React.ReactNode
  className?: string
  as?: 'h1' | 'h2' | 'h3' | 'span' | 'div'
}

const GlitchText: React.FC<GlitchTextProps> = ({
  children,
  className = '',
  as: Component = 'h1',
}) => {
  return (
    <Component className={`${styles.glitchText} ${className}`} data-text={children}>
      {children}
    </Component>
  )
}

export default GlitchText
